import React, { FC, ReactNode, useCallback, useRef } from "react";
import { itemCSS, afterCSS } from "../../../styles/previewStyle";
import { Field } from "../form/FieldHandler";

const ListBlockFormItem: FC<{
  field?: Field;
  label: string;
  children: ReactNode;
}> = ({ field, label, children }) => {
  const ref = useRef<HTMLDivElement>(null);

  const handleClick = useCallback(() => {
    const element = ref.current;
    if (!element) {
      return;
    }
    const inputs = element.getElementsByTagName("input");
    if (inputs.length) {
      inputs[0].focus();
    }
    const selects = element.getElementsByTagName("select");
    if (selects.length) {
      selects[0].focus();
    }
    const textareas = element.getElementsByTagName("textarea");
    if (textareas.length) {
      textareas[0].focus();
    }
  }, []);

  const fieldColor = field ? (field.required ? "red" : field.key && field.key.indexOf("_") === 0 ? "blue" : "black") : "black";

  return (
    <li className={field?.error ? "error" : ""}>
      <div className="item-content" onClick={handleClick}>
        <div className="item-inner">
          <div
            className="item-title label"
            style={{
              color: fieldColor,
              overflow: "visible",
              overflowWrap: "break-word",
              whiteSpace: "normal",
              wordWrap: "break-word",
            }}
          >
            {label}
            {field?.required ? " *" : ""}
          </div>
          <div className="item-input" style={field?.error ? itemCSS : undefined} ref={ref}>
            {children}
          </div>
          {field?.error ? (
            <div className="item-input" style={{ paddingLeft: "10px" }}>
              <i className="after fa fa-exclamation-triangle" style={afterCSS}></i>
              <span>{field.error.message}</span>
            </div>
          ) : null}
        </div>
      </div>
    </li>
  );
};

export default ListBlockFormItem;
